/* ============================================================
   RACEFACTORY — Gallery left thumbs: sync max-height thumbs col
   = altezza main image. Scope: #template-product, #template-product-service.
   Setta CSS var --rf-gallery-h sul .product-gallery--left-thumbnails.
   ============================================================ */
(function () {
  'use strict';

  function sync(gallery) {
    var main = gallery.querySelector('.product-gallery__main');
    if (!main) return;
    var h = main.getBoundingClientRect().height;
    if (h > 0) gallery.style.setProperty('--rf-gallery-h', h + 'px');
  }

  function init() {
    var root = document.getElementById('template-product') ||
               document.getElementById('template-product-service');
    if (!root) return;

    var galleries = root.querySelectorAll('.product-gallery--left-thumbnails');
    if (!galleries.length) return;

    galleries.forEach(function (g) {
      sync(g);
      // Re-sync after flickity init + images load
      setTimeout(function () { sync(g); }, 300);
      setTimeout(function () { sync(g); }, 1000);

      // Watch main image height changes
      if (typeof ResizeObserver !== 'undefined') {
        var main = g.querySelector('.product-gallery__main');
        if (main) {
          var ro = new ResizeObserver(function () { sync(g); });
          ro.observe(main);
        }
      }
    });

    window.addEventListener('resize', function () {
      galleries.forEach(sync);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
